export default __webpack_public_path__ + "static/media/mobile1.634d36ca.png";